export const content = {
    domain: "Lendumo",
    footer: "lenduone.com",
    title1: "Loans with Your Needs in Mind",
  };
  